import { useEffect, useContext, useState } from "react";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _btn_ from "@Elementos/Boton";
import * as _ipt_ from "@Elementos/Input";
import * as _anim_ from "@Elementos/Animaciones";
import Logo from "@Imagenes/Logo.png";
import img_usuario from "@Imagenes/Iconos/usuario.png";
import img_opcionesUsuario from "@Imagenes/Iconos/flechaOpciones.png";
import img_notificacion from "@Imagenes/Iconos/notificacion.png";
import MenuOpciones from "@MenuOpciones/MenuOpciones";
import ContenidoCentral from "@ContenidoCentral/ContenidoCentral";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";
import ModalInformacion from "@ModalInformacion/ModalInformacion";
import "./Principal.css";

function Principal() {
  const { ecv_u, cv_u, esComputadora, opcionMenu, eopcionMenu, navegacion, enavegacion, usuarioSesion, rolUsuarioSesion} =
    useContext(Contexto);
  const [mostrarOpcionesUsuario, emostrarOpcionesUsuario] = useState(false);
  const origenComponente = "Principal";
  const [v_c, ev_c] = useState({
    //MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},
    modal_boton_cerrar_visible: true,
    //PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_texto: "",
    //PROCESANDO ACCION
    procesandoAccion_mostrar: false,
    procesandoAccion_texto: "",
    //POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_texto: "",

    //CERAR SESION
    exitoCerrarSesion: false,
  });
  useEffect(() => {
    // const { respuesta, controlLlamado } = _api_.f_inicioSesion();
    // respuesta.then((datos) => {
    //   console.log("exito Principal", datos);
    // });
    return () => {
      // controlLlamado.abort();
    };
  }, []);

  return (
    <div id="principal-app">
      {v_c.modal_mostrar && (
        <ModalInformacion
          vBotonCerrar={v_c.modal_boton_cerrar_visible}
          estilos={v_c.modal_estilos}
          titulo={v_c.modal_titulo}
          fCerrar={() => {
            _f_.asignar(ev_c, {
              modal_mostrar: false,
              preConfirmar_mostrar: false,
            });
            if (v_c.exitoCerrarSesion) {
              _f_.eliminarCookies();
              window.location.href = "/";
              window.location.replace("/");
            }
          }}>
          {v_c.preConfirmar_mostrar && (
            <_preconf_.PreConfirmacion
              texto={"¿Seguro que desea cerrar sesión?"}
              fBotonCancelar={() => {
                _f_.asignar(ev_c, { modal_mostrar: false });
              }}
              fBotonAceptar={() => {
                const cerrarSesionAPI = _api_.f_cerrarSesion({
                  origen: origenComponente,
                  timeout: 5000,
                });
                cerrarSesionAPI.respuesta.then((dPC) => {
                  _f_.asignar(ecv_u, dPC, true, origenComponente);
                  if (!dPC.error) {
                    _f_.asignar(ev_c, {
                      postConfirmar_texto: dPC.contenido.mensaje,
                      procesandoAccion_mostrar: false,
                      postConfirmar_mostrar: true,
                      modal_titulo: "✅ Éxito",
                      exitoCerrarSesion: true,
                      modal_boton_cerrar_visible: true,
                    });
                  } else {
                    _f_.asignar(ev_c, {
                      modal_mostrar: false,
                    });
                  }
                });
                _f_.asignar(ev_c, {
                  preConfirmar_mostrar: false,
                  modal_titulo: "⏳ Cerrando Sesión",
                  procesandoAccion_mostrar: true,
                  modal_boton_cerrar_visible: false,
                });
              }}
            />
          )}
          {v_c.procesandoAccion_mostrar && <_procAcc_.ProcesandoAccion />}
          {v_c.postConfirmar_mostrar && (
            <_posconf_.PostConfirmacion
              texto={v_c.postConfirmar_texto}
              fBotonDeAcuerdo={() => {
                _f_.eliminarCookies();
                window.location.href = "/";
                window.location.replace("/");
              }}></_posconf_.PostConfirmacion>
          )}
        </ModalInformacion>
      )}
      <div id="p-a-contenedor" escomputadora={String(esComputadora)}>
        <div id="p-a-contenido">
          <div id="p-a-barra-superior">
            <div className="p-a-b-s-logo">
              <img src={Logo} className={"p-a-b-s-logo-img"} />
            </div>
            <div className={"p-a-usuario"}>
              <img className={"p-a-u-img"} src={img_notificacion} />
              <span className={"p-a-u-datos"}>
                <span className={"p-a-u-d-nombre-usuario"}>
                  {_f_.obtenerCookie("nomUsuario").toUpperCase()} {_f_.obtenerCookie("apePaterno").toUpperCase()} -{" "}
                  {_f_.obtenerCookie("usuario").toUpperCase()}
                </span>
                <span className={"p-a-u-d-rol"}>{_f_.obtenerCookie("dscRol").toUpperCase()}</span>
              </span>
              <img className={"p-a-u-img p-a-u-img-usuario"} src={img_usuario} />
              <img
                onClick={(evento) => {
                  emostrarOpcionesUsuario((prev) => !prev);
                }}
                className={`p-a-u-img p-a-u-opus ${mostrarOpcionesUsuario ? "p-a-u-opciones-girado" : ""}`}
                src={img_opcionesUsuario}
              />
            </div>
          </div>
          <div className={`principalCSS-menuOpciones ${mostrarOpcionesUsuario ? "mostrar" : ""}`}>
            <div className="principalCSS-titulo-componente">Menú de Usuario</div>
            {Array.from({ length: 1 }).map((menu, idx_menu) => {
              let opciones = [];
              // if (usuarioSesion == "AMAYTA" || usuarioSesion == "ASUCASAIRE") {
              if(rolUsuarioSesion == 'SADM01'){
                opciones = [
                  { prog: "CONFSISTEMA", dsc: "Configuración del Sistema" },
                  { prog: "", dsc: "Cerrar Sesión", accion: "SALIRSISTEMA" },
                ];
              } else {
                opciones = [{ prog: "", dsc: "Cerrar Sesión", accion: "SALIRSISTEMA" }];
              }

              return opciones?.map((opcion, idx_opcion) => {
                return (
                  <div
                    key={idx_opcion}
                    className="principalCSS-opcion"
                    onClick={() => {
                      if (opcion?.accion == "SALIRSISTEMA") {
                        console.log("entre a salir del sistema");
                        _f_.asignar(ev_c, {
                          modal_mostrar: true,
                          modal_titulo: "Cerrar Sesión",
                          preConfirmar_mostrar: true,
                        });
                      }
                      emostrarOpcionesUsuario((prev) => !prev);
                      console.log(opcion?.prog, opcion?.dsc);
                      _f_.f_logicaNavegacion(opcion?.prog, opcion?.dsc, opcionMenu, eopcionMenu, enavegacion);
                    }}>
                    {opcion?.dsc}
                  </div>
                );
              });
            })}
          </div>
          <div id="p-a-central">
            <ContenidoCentral />
          </div>
        </div>
        <div id="p-a-menu-opciones">
          <MenuOpciones />
        </div>
      </div>
    </div>
  );
}

export default Principal;
